import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";

import { ROUTES } from "../../../../constants";
import { Images } from "../../../../assets/images";
import { customToast } from "../../../../shared";
import BackButton from "../../../../shared/components/IconButton/BackButton";
import { eventBookingActions } from "../../../../redux/actions";
import ShutterBSelectionPage from "./ShutterBSelectionPage";

const ShutterBSelectionForm = ({
  isProfileViewShow,
  availableShutterBs,
  assignShutterb,
  getAvailableShutterb,
  setIsProfileViewShow,
  notifyAdminToAssignShutterb,
}) => {
  const { t } = useTranslation("common");

  const { token, eventId, orderItemId } = useParams();
  const [isThankYouPageVisible, setIsThankYouPageVisible] = useState(false);
  const [isNotifyAdmin, setIsNotifyAdmin] = useState(false);

  // Fetch available shutterBs on component mount
  useEffect(() => {
    getAvailableShutterb(eventId, token);
    // eslint-disable-next-line
  }, []);

  // Handle "Back" button click in profile view
  const handlePrevious = () => {
    setIsProfileViewShow(false);
  };

  const handleSubmit = () => {
    const selectedShutterb = availableShutterBs[0]?.items?.find(
      (item) => item?.isSelected
    );

    if (selectedShutterb) {
      const dataToSend = {
        eventId: eventId,
        token: token,
        orderItemId: orderItemId,
        shutterbId: selectedShutterb.id,
      };
      // Assign shutterB and show thank-you page on success
      assignShutterb(dataToSend, setIsThankYouPageVisible);
    } else {
      customToast("please select shutterb for event", toast.TYPE.ERROR);
    }
  };

  const handleNotifyAdmin = () => {
    if (eventId && orderItemId) {
      notifyAdminToAssignShutterb(eventId, orderItemId, setIsNotifyAdmin);
    }
  };

  return (
    <>
      {isThankYouPageVisible || isNotifyAdmin ? (
        <div className="thank-you-page d-flex justify-content-center">
          <div className="thank-you-box text-center px-3 px-md-5 py-5">
            <div className="check-icon mb-4">
              <img src={Images.TickMark} alt="Tick Mark" />
            </div>
            <h2 className="thank-you-heading mb-3">thank you!</h2>

            <p className="thank-you-text mb-4 px-1 px-md-5">
              {isNotifyAdmin
                ? "admin has been notified to assign a shutterb."
                : "your booking is complete and the shutterb is assigned to the event."}
            </p>
            <button className="my-event-btn button-common button-fill">
              <Link to={ROUTES.MY_EVENTS_TAB}>my events</Link>
            </button>
          </div>
        </div>
      ) : (
        <div className="event-booking-container position-relative my-5">
          <div className="heading-wrapper text-center mb-5">
            <h2 className="heading-title mb-2">{t("select_your_shutterb")}</h2>
            <hr className="heading-hr" />
          </div>
          <div className="shutterb-selection-container active">
            <ShutterBSelectionPage handleNotifyAdmin={handleNotifyAdmin} />

            {/* Submit Button (only shown if not in profile view and shutterB options exist) */}
            {availableShutterBs[0]?.items?.length && !isProfileViewShow ? (
              <div className="d-flex justify-content-center align-items-center sticky-button-row sticky-desktop mt-5">
                <button
                  type="button"
                  className="button-common button-fill"
                  onClick={() => handleSubmit()}
                >
                  {t("submit")}
                </button>
              </div>
            ) : null}

            {/* Back Button in Profile View */}
            {isProfileViewShow && (
              <BackButton
                className="event-back-button"
                onClick={handlePrevious}
                text={t("shutterb_results")}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  isProfileViewShow: state.eventBooking.isProfileViewShow,
  availableShutterBs: state.eventBooking.availableShutterBs,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setIsProfileViewShow: (data) =>
    dispatch(eventBookingActions.setIsProfileViewShow(data)),
  getAvailableShutterb: (eventId, token) =>
    dispatch(eventBookingActions.getAvailableShutterb(eventId, token)),
  assignShutterb: (data, setIsThankYouPageVisible) =>
    dispatch(
      eventBookingActions.assignShutterb(data, setIsThankYouPageVisible)
    ),
  notifyAdminToAssignShutterb: (eventId, orderItemId, setIsNotifyAdmin) =>
    dispatch(
      eventBookingActions.notifyAdminToAssignShutterb(
        eventId,
        orderItemId,
        setIsNotifyAdmin
      )
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShutterBSelectionForm);
